import { ColumnState } from 'ag-grid-community';
import { defaultSYS4010_R01Dto, SYS4010_R01Dto } from 'src/containers/mes/SYS/SYS4010_R01/Dto_SYS4010_R01';
import { create } from 'zustand';

export interface SYS4010_R01Filter {
	compNm: string;
}

export interface Store_SYS4010_R01 {
	SYS4010_R01Filter: SYS4010_R01Filter;
	SYS4010_R01PastFilter: SYS4010_R01Filter;
	setSYS4010_R01Filter: (filter: Partial<SYS4010_R01Filter>) => void;
	setSYS4010_R01PastFilter: (filter: Partial<SYS4010_R01Filter>) => void;

	SYS4010_R01List: SYS4010_R01Dto[];
	setSYS4010_R01List: (SYS4010_R01List: SYS4010_R01Dto[]) => void;

	selectedSYS4010_R01: SYS4010_R01Dto | undefined;
	setSelectedSYS4010_R01: (selectedSYS4010_R01: SYS4010_R01Dto | undefined) => void;
	initSelectedSYS4010_R01: () => void;

	editSYS4010_R01: SYS4010_R01Dto;
	setEditSYS4010_R01: (data: SYS4010_R01Dto) => void;

	columnState: ColumnState[] | null;	setColumnState: (state: ColumnState[] | null) => void;

	scrollTop: number | null;
	setScrollTop: (top: number | null) => void;

	allCount: number;						setAllCount: (allCount: number) => void;
	

	initData: () => void;
}

export const defaultSYS4010_R01Filter: SYS4010_R01Filter = {
	compNm: ''
}

export const useSYS4010_R01Store = create<Store_SYS4010_R01>((set) => ({
	SYS4010_R01Filter: defaultSYS4010_R01Filter,
	SYS4010_R01PastFilter: defaultSYS4010_R01Filter,
	setSYS4010_R01Filter: (filter) => set((state) => ({
		SYS4010_R01Filter: {
			...state.SYS4010_R01Filter,
			...filter
		}
	})),
	setSYS4010_R01PastFilter: (filter) => set((state) => ({
		SYS4010_R01PastFilter: {
			...state.SYS4010_R01PastFilter,
			...filter
		}
	})),

	SYS4010_R01List: [],
	setSYS4010_R01List: (SYS4010_R01List: SYS4010_R01Dto[]) => set((state) => {
		return {
			...state,
			SYS4010_R01List
		}
	}),

	selectedSYS4010_R01: undefined,
	setSelectedSYS4010_R01: (selectedSYS4010_R01: SYS4010_R01Dto | undefined) => set((state) => {

		return {
			...state,
			selectedSYS4010_R01 : selectedSYS4010_R01,
		}
	}),
	initSelectedSYS4010_R01: () => set({ selectedSYS4010_R01: undefined, editSYS4010_R01: { ...defaultSYS4010_R01Dto, valueIndex: 0 } }),
	
	editSYS4010_R01: defaultSYS4010_R01Dto,
	setEditSYS4010_R01: (data: SYS4010_R01Dto) => set((state) => {
		// console.log(data);
		let editSYS4010_R01 = defaultSYS4010_R01Dto;
		if (data) {
			editSYS4010_R01 = {
				...data
			}
		}
		return { ...state, editSYS4010_R01: editSYS4010_R01 };
	}),

	columnState: null,		setColumnState: (state) => set({ columnState: state }),

	scrollTop: null,
	setScrollTop: (top: number | null) => set({ scrollTop: top }),

	allCount: 0,					setAllCount: (allCount: number) => set({ allCount }),
						

	initData: () => set((state) => ({
		...state,
		SYS4010_R01Filter: defaultSYS4010_R01Filter,
		SYS4010_R01PastFilter: defaultSYS4010_R01Filter,
		SYS4010_R01List: [],
		selectedSYS4010_R01: undefined,
		editSYS4010_R01: defaultSYS4010_R01Dto,
		allCount: 0,
		scrollTop: null,
	})),
	
}));
